<form [formGroup]="premieAOV" (change)=saveForm()>
    <div *ngIf="betaaldePremieAOV.length > 0">
        <div formArrayName="betaaldePremieAOV">
            <div *ngFor="let item of betaaldePremieAOV.controls; let i = index; "
                          [formGroupName]="i">
                <div class="row col-auto">
                    <snelstart-ui-text-form-control formControlName="omschrijving"
                                                    id="omschrijving"
                                                    [label]="i === 0 ? 'Omschrijving AOV-verzekering' : ''"
                                                    class="custom-input-250"
                                                    (change)="saveForm()"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-text-form-control formControlName="polisnummer"
                                                    id="polisnummer"
                                                    [label]="i === 0 ? 'Polisnummer' : ''"
                                                    class="custom-input-250"
                                                    (change)="saveForm()"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control formControlName="bedrag"
                                                      id="bedragAlimentatie"
                                                      [label]="i === 0 ? 'Bedrag' : ''"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      (change)="saveForm()"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button class="delete"
                                                id="buttonDeleteKosten"
                                                type="secondary"
                                                size="medium"
                                         icon="trash"
                                                iconType="light"
                                                (click)="verwijderRijPremieAOV(i)"
                                                [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="betaaldePremieAOV.length === 0">
        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                             (click)="addRijLoonPremieAOV()">Premie arbeidsongeschiktheidsverzekering
        </snelstart-ui-button>
    </div>
    <div *ngIf="betaaldePremieAOV.length > 0">
        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                             (click)="addRijLoonPremieAOV(); saveForm()">Premie arbeidsongeschiktheidsverzekering toevoegen
        </snelstart-ui-button>
    </div>
</form>


